import { TypographyColor } from 'melp-design/components';
import { DiscountCodeStatus } from './admin-discount-codes.types';

export const COLOR_BY_STATUS: Record<DiscountCodeStatus, TypographyColor> = {
  available: 'success',
  expired: 'error',
  archived: 'textSecondary',
  revealed: 'primary',
};
